(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        const _ = require('lodash');
        module.exports = definition(_);

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.postAutoTags = definition(window._);

    }

    function definition(_) {

        // NOTE: if you add any values to this table, make sure you update the post_auto_tag db table as well.
        const def = {
            UserDefinedQuery: {
                id: 1,
                name: 'UserDefinedQuery',
                description: 'Tag posts matching your search query',
                detailedDescription: 'This rule will automatically tag any posts matching your search query.',
                definition: 'Search query like "Sample Post" OR example*',
                dropdownName: 'Keyword-Based',
                icon: 'fa-search',
                editable: true
            },
            ContestDetection: {
                id: 2,
                name: 'ContestDetection',
                dropdownName: 'Contest or Giveaway',
                description: 'Detects a likely contest or giveaway post',
                detailedDescription: 'Detects a likely contest or giveaway post',
                definition: 'Detects a likely contest or giveaway post',
                suggestedName: 'Contests',
                icon: 'fa-gift'
            },
            UGCDetection: {
                id: 3,
                name: 'UGCDetection',
                dropdownName: 'User-Generated Content',
                description: 'Identify Likely User Generated Content',
                detailedDescription: 'Photo or video attributed to another user',
                definition: 'Photo or video attributed to another user',
                suggestedName: 'UGC',
                icon: 'fa-camera'
            },
            LinkInBioDetection: {
                id: 4,
                name: 'LinkInBioDetection',
                dropdownName: 'Link in Bio',
                description: 'Instagram or TikTok post caption refers to a link in bio',
                detailedDescription: 'Instagram or TikTok post caption refers to a link in bio',
                definition: 'Instagram or TikTok post caption refers to a link in bio',
                suggestedName: 'Link in Bio',
                icon: 'fa-link',
                channelIcons: ['fa-instagram', 'fab fa-tiktok']
            },
            HighEngagement: {
                id: 5,
                name: 'HighEngagement',
                dropdownName: 'High-Engagement Detection',
                description: 'Tag posts with high engagement',
                detailedDescription: 'Posts with eng. rates higher than <%- engagement_rate %>% and total eng. greater than <%- engagement_total %>.',
                definition: 'Posts with high engagement rates and totals',
                suggestedName: 'High Engagement',
                icon: 'fa-link',
                editable: true,
                defaultValues: {
                    engagement_rate: {
                        gte: 0.04
                    },
                    engagement_total: {
                        gte: 50
                    }
                }
            }
        };

        const byId = _.keyBy(def, 'id');
        def.findById = function (id) {
            return byId[id];
        };

        def.isEditable = function (id) {
            return Boolean(byId[id].editable);
        };

        return def;
    }
})();
